import type { Location } from "react-router-dom";

/**
 * Builds a safe in-app return path from router `location.state.from`.
 * Rejects protocol-relative URLs and non-root-relative paths.
 */
export function getSafeInternalReturnPath(
	from: Pick<Location, "pathname" | "search" | "hash"> | undefined | null,
): string | null {
	if (!from?.pathname) return null;
	const path = `${from.pathname}${from.search ?? ""}${from.hash ?? ""}`;
	if (!path.startsWith("/") || path.startsWith("//")) return null;
	return path;
}

/** Validates a full internal path string (e.g. from persisted post-login target). */
export function parseSafeInternalPath(path: string | null | undefined): string | null {
	if (path == null || path === "") return null;
	const p = path.trim();
	if (!p.startsWith("/") || p.startsWith("//")) return null;
	return p;
}

/** `?redirect=` on the sign-in page: internal return path after auth (from AuthGuard embed redirect). */
export function parseInternalRedirectParam(search: string): string | null {
	if (!search) return null;
	const normalized = search.startsWith("?") ? search.slice(1) : search;
	const raw = new URLSearchParams(normalized).get("redirect");
	if (!raw) return null;
	try {
		return parseSafeInternalPath(decodeURIComponent(raw));
	} catch {
		return null;
	}
}
